






















import { Component, PropSync, Prop, Vue, Watch } from "vue-property-decorator";
import { service } from "@modules/newCommunity/setup";
import { mixins } from "vue-class-component";
import commonMixins from "@mixins/commonNewMixins";
@Component({
  name: "templateTitleDialog",
  components: {},
})
export default class templateTitleDialog extends mixins(commonMixins) {
  @PropSync("modalVisible", { type: Boolean }) visible!: Boolean;

  inputValue = "";
  loading = false;

  form: any = {
    title: "",
  };

  onOpen() {
    // console.log("onopen");
    this.form.title = "";
    // (this.$refs.form as any).clearValidate();
  }
  async validatorTitle(rule: any, value: any, callback: any) {
    // console.log("validator", this.basicData, this.basicData.cover, this.basicData.introduce);
    let res: any = null;
    res = await service.questionnaireTemplateCheckTitleUnique({ title: value, id: "", communityId: this.VX_comtyId, questionnaireType: "QUESTIONNAIRE", questionnaireSource: "DOCTOR", questionnaireProperty: "ACTIVITY_INTERACT" });

    // console.log("formtemplateCheckTitleUnique", res);
    if (res) {
      callback();
    } else {
      callback(Error("名称已存在"));
    }
  }
  confirm() {
    (this.$refs["form"] as any).validate(async (valid: any) => {
      if (valid) {
        this.visible = false;
        this.$emit("success", this.form.title);
      } else {
        return false;
      }
    });
  }

  // contentChange() {
  //   this.$emit("input", this.inputValue);
  // }
}
